(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var interfaceMeta = kotlin_kotlin.$_$.e9;
  var Unit_getInstance = kotlin_kotlin.$_$.k4;
  var classMeta = kotlin_kotlin.$_$.v8;
  //endregion
  //region block: pre-declaration
  //endregion
  function Settings() {
  }
  Settings.$metadata$ = interfaceMeta('Settings');
  function JsSettings_init_$Init$(delegate, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      delegate = localStorage;
    JsSettings.call($this, delegate);
    return $this;
  }
  function JsSettings_init_$Create$(delegate, $mask0, $marker) {
    return JsSettings_init_$Init$(delegate, $mask0, $marker, Object.create(JsSettings.prototype));
  }
  function JsSettings(delegate) {
    this.e4z_1 = delegate;
  }
  JsSettings.prototype.g1u = function (key) {
    return this.e4z_1.removeItem(key);
  };
  JsSettings.prototype.c4z = function (key, value) {
    // Inline function 'org.w3c.dom.set' call
    var tmp0_set = this.e4z_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_set;
    tmp$ret$0[key] = value;
  };
  JsSettings.prototype.d4z = function (key) {
    var tmp$ret$1;
    // Inline function 'org.w3c.dom.get' call
    var tmp0_get = this.e4z_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_get;
    tmp$ret$1 = tmp$ret$0[key];
    return tmp$ret$1;
  };
  JsSettings.$metadata$ = classMeta('JsSettings', [Settings]);
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = JsSettings_init_$Create$;
  //endregion
  return _;
}(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js')));

